module.exports = __webpack_public_path__ + "img/village-search.f68af0e.png";